import styled from 'styled-components'
import theme from 'theme_'

export const Container = styled.div`
  @media ${theme.devices.desktop} {
    padding: ${(p) =>
      `${p.theme.spacing.tiny} ${p.theme.spacing.tiny} ${p.theme.spacing.tiny} 0`};
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    &:hover {
      background-color: ${theme.overlay.newDropdownBlack};
      border-radius: ${(p) => p.theme.spacing.xs};
      cursor: pointer;
    }
  }
`

export const LanguageLabelContainer = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: ${(p) =>
    `${p.theme.spacing.xxs} ${p.theme.spacing.base} ${p.theme.spacing.xxs} 27px`};
  @media ${theme.devices.desktop} {
    padding: ${(p) =>
      `${p.theme.spacing.xs} ${p.theme.spacing.xxs} ${p.theme.spacing.xxs} ${p.theme.spacing.base}`};
  }
`

export const LangLabel = styled.label`
  font-size: ${(p) => p.theme.spacing.sm};
  color: ${(p) => p.theme.colors.lightGrey};
  text-transform: capitalize;
  @media ${theme.devices.desktop} {
    font-size: ${(p) => p.theme.spacing.base};
  }
`

export const ChevronContainer = styled.div<{ isOpen: boolean }>`
  padding-right: 2px;
  @media ${theme.devices.desktop} {
    display: flex;
    transition: transform 0.2s ease;
    margin-right: ${(p) => `${p.theme.spacing.xs}`};
    padding-right: 0;
  }
  ${(p) =>
    p.isOpen &&
    `
    transform: rotate(180deg);
  `}
`

export const FlagImage = styled.img`
  object-fit: cover;
  vertical-align: middle;
  width: 32px;
  position: relative;
  bottom: 2px;
  margin-right: ${(p) => `${p.theme.spacing.s}`};
  @media ${theme.devices.desktop} {
    margin-right: ${(p) => `${p.theme.spacing.xs}`};
  }
`

export const SelectedFlagImage = styled(FlagImage)`
  width: 22px;
  height: 14px;
  @media ${theme.devices.desktop} {
    top: 0;
  }
`
